import { Typography } from "@mui/material";
import { AppModal, bodyTextSx } from "global/components/AppModal";

interface CustomSeatActionDialogProps {
  isDialogOpen: boolean;
  /** Heading, e.g. "Deactivate Ann". */
  title: string;
  /** What is about to happen. */
  description: string;
  confirmLabel: string;
  isSubmitting?: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

/**
 * Confirmation for the user actions that fill or free a seat — deactivate,
 * reactivate, delete.
 *
 * Under the buy-upfront model none of these move money: the account already
 * paid for its seats, so the copy must never mention a charge, credit or
 * refund. The only thing that can stop the action is having no free seat,
 * which the API answers with a `406`.
 */
const CustomSeatActionDialog = ({
  isDialogOpen,
  title,
  description,
  confirmLabel,
  isSubmitting = false,
  onConfirm,
  onClose,
}: CustomSeatActionDialogProps) => (
  <AppModal
    open={isDialogOpen}
    onClose={onClose}
    title={title}
    /*
      Deactivating and deleting are both reversible here — the seat is freed,
      not billed — so this is a confirmation rather than a destructive warning.
    */
    tone="neutral"
    size="sm"
    busy={isSubmitting}
    primaryLabel={confirmLabel}
    onPrimary={onConfirm}
    primaryLoading={isSubmitting}
    cancelLabel="Cancel"
    onCancel={onClose}
  >
    <Typography sx={bodyTextSx}>{description}</Typography>
  </AppModal>
);

export default CustomSeatActionDialog;
